import { FC, useCallback, useState } from 'react';
import { PikHistory } from './PikHistory';
import { IPikHistoryItem, PikHistoryItem } from './internal/models/PikHistoryItem';
import { PikHistoryItemsService } from './internal/services/PikHistoryItemsService';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { ChipsOption } from './internal/models/ChipsOption';

const pikHistoryItemsService = new PikHistoryItemsService([
  new PikHistoryItem(
    new ChipsOption('1994'),
    'Начало пути',
    'В 1994 мы создали «Первую Ипотечную Компанию», которая в дальнейшем была переименована в ПИК.',
  ),
  new PikHistoryItem(
    new ChipsOption('1998'),
    'Первыми запустили ипотеку',
    'Мы стремились сделать покупку жилья доступной каждому. Поэтому в 1998 году первыми в России запустили ипотечные программы.',
  ),
  new PikHistoryItem(
    new ChipsOption('2002'),
    'Стали первым застройщиком, который выпустил облигации',
    'Строительные компании в России не продавали ценные бумаги на бирже. Мы стали первыми, выпустив собственные рублевые облигации в 2002 году.',
  ),
  new PikHistoryItem(
    new ChipsOption('2008'),
    'Стали одним из крупнейших застройщиков в стране',
    'В 2008 году Правительство России включило нашу компанию в список системообразующих организаций российской экономики.',
  ),
  new PikHistoryItem(
    new ChipsOption('2011'),
    'Задали новый тренд на рынке недвижимости',
    'Мы стали первым девелопером в России, который начал заниматься озеленением территории вокруг домов, строительством детских площадок во дворах, школ и садиков рядом с домом. Через некоторое время такой подход к созданию проекта стал новым стандартом для всех застройщиков в стране.',
  ),
  new PikHistoryItem(
    new ChipsOption('2015'),
    'ПИК был признан лучшим девелопером жилой недвижимости в Европе',
    'В 2015 мы начали производить и первые вывести на рынок принципиально новые продукты индустриального и монолитного домостроения. Они отличались более высокими эстетическими и потребительскими характеристиками. Тогда же нас признали лучшим девелопером жилой недвижимости в Европе.',
  ),
  new PikHistoryItem(
    new ChipsOption('2017'),
    'Построили рекордные 2 млн м² недвижимости',
    'К 2017 году мы организовали свой единый производственный комплекс из 5 заводов. Собственное производство позволило нам создавать больше проектов и помогло увеличить скорость работы. Жители начали переезжать в свои новые квартиры быстрее. Так в 2017 мы впервые перешагнули отметку строительства в 2 млн м² недвижимости за год.',
  ),
  new PikHistoryItem(
    new ChipsOption('2018'),
    'Первыми внедрили эскроу-счета',
    'До 2018 года многие боялись покупать квартиры в строящихся домах. Но введение счетов эскроу полностью изменило эту ситуацию. В октябре 2018 года мы первые в России заключили крупнейшую сделку с использованием эскроу-счета. Закон, обязывающий застройщиков проводить все сделки только с помощью счетов эскроу, вышел только в 2019 году.',
  ),
  new PikHistoryItem(
    new ChipsOption('2019'),
    'Провели первую онлайн-сделку',
    'В декабре 2019 года мы были первым российским девелопером, который запустил онлайн-оплату недвижимости картой на сайте.',
  ),
  new PikHistoryItem(
    new ChipsOption('2020'),
    'Полностью ушли в онлайн',
    'Во время пандемии 2020 года мы оперативно перевели все наши сервисы по выбору, бронированию, покупке и аренде жилья в онлайн. Это изменило всю отрасль недвижимости в России, в том числе, систему получения ипотеки. Теперь выбрать квартиру, оформить ипотеку и оплатить покупку можно не выходя из дома.',
  ),
  new PikHistoryItem(
    new ChipsOption('2021'),
    'Построили 3 млн м²',
    'В 2021 году мы ввели в эксплуатацию более 3 млн м² жилья. А ещё расширили линейку своих продуктов и запустил компанию Forma, специализирующуюся на жилье бизнес-класса.',
  ),
  new PikHistoryItem(
    new ChipsOption('2022'),
    'ПИК расширил линейку продуктов',
    'В 2022 году мы провели первую в России сделку по IT-ипотеке. В этот же год мы запустили новую линейку проектов повышенного комфорта ПИК+ и объявили о запуске нового маркетплейса «ПИК-Маркет».',
  ),
  new PikHistoryItem(
    new ChipsOption('2023'),
    'Создали отдельный бренд для проектов коммерческой недвижимости',
    'В 2023 мы создали Parametr. В рамках этого бренда мы проектируем, строим, продаем помещения для бизнеса, промышленные и логистические парки. Наши пространства уже продуманы для эффективной работы компаний любого масштаба.',
  ),
  new PikHistoryItem(
    new ChipsOption('2024'),
    'Переосмысление бренда и появление проектов с новым уровнем комфорта',
    'В 2024 ПИК запустил новую линейку новостроек «Серия плюс». В ней мы собрали все лучшие архитектурные и функциональные решения, которые выводят жизнь в квартире на новый уровень комфорта.',
  ),
]);

export const PikHistoryContainer: FC = () => {
  const { logger } = useApplicationContext();

  const [activePikHistoryItem, setActivePikHistoryItem] = useState<IPikHistoryItem>(pikHistoryItemsService.defaultItem);

  const handleChange = useCallback<(value: string[]) => void>(
    value => {
      setActivePikHistoryItem(pikHistoryItemsService.getActiveItem(value[0], logger));
    },
    [logger],
  );

  return (
    <PikHistory
      chipsOptions={pikHistoryItemsService.chipsOptions}
      activePikHistoryItem={activePikHistoryItem}
      onChange={handleChange}
    />
  );
};
